import {Component, OnInit} from '@angular/core';
import {Stack} from '../model/stack.model';
import {ApiService} from '../service/api.service';

@Component({
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {

  stacks: Stack[] = [];
  loading = true;

  constructor(private apiService: ApiService) {
  }

  ngOnInit() {
    this.apiService.send({
      command: 'get_stacktrace',
      request: {
        id: this.apiService.getParam('$id')
      }
    }, (response, headers) => {
      response = response.response;
      if (!response.error) {
        let stacks: Stack[] = [];

        for (const stack of response) {
          stacks.push({
            message: stack.message,
            elements: stack.elements
          });
          this.stacks = stacks;
        }
      }
    });
  }
}
